import Vue from 'vue';
import { createDecorator } from 'vue-class-component';
import { container } from 'tsyringe';

export function Service(token?: string) {
  return (target: Vue, key: string) => {
    const metadata: any = Reflect.getMetadata('design:type', target, key);
    if (!token && !metadata) {
      return;
    }
    createDecorator((options, key) => {
      options.mixins = options.mixins || [];

      options.mixins.push({
        beforeCreate() {
          (this as any)[key] = token
            ? container.resolve(token)
            : container.resolve(metadata);
        }
      });
    })(target, key);
  };
}
